import { Modal, Form, Button, Alert } from "react-bootstrap";
import {
  TemplateTextTypeModel,
  templateTextTypeApi,
} from "../../api/TemplateTextTypeApi";
import { SyntheticEvent, useState } from "react";
import { ValidationProblem, formErrors } from "../../api/backendApi";

interface TemplateTextTypeModalProps {
  templateTextType: TemplateTextTypeModel;
  isCreate: boolean;
  onChange: (templateTextTypeModel: TemplateTextTypeModel) => void;
  onCancel: () => void;
  modalText: string;
}

function TemplateTextTypeModal({
  templateTextType: initialTemplateTextType,
  isCreate,
  onChange,
  onCancel,
  modalText,
}: TemplateTextTypeModalProps) {
  const [templateTextType, setTemplateTextType] = useState(
    initialTemplateTextType,
  );
  const [show, setShow] = useState(true);
  const [errors, setErrors] = useState<formErrors>({});

  const handleClose = () => {
    setShow(false);
    onCancel();
    setTemplateTextType(initialTemplateTextType);
  };

  const handleSubmit = (event: SyntheticEvent) => {
    event.preventDefault();

    let call = isCreate
      ? templateTextTypeApi.createTemplateTextType(templateTextType)
      : templateTextTypeApi.updateTemplateTextType(
          templateTextType,
          initialTemplateTextType.name,
        );

    call.then((result) => {
      if (result.ok) {
        onChange(templateTextType);
        handleClose();
      } else {
        let validation = result.problem as ValidationProblem;
        if (validation.validation) {
          setErrors(validation.validation);
        } else {
          let errors: formErrors = {};
          errors[""] = [`${result.problem.title} [${result.problem.instance}]`];
          setErrors(errors);
        }
      }
    });
  };

  const handleChange = (event: any) => {
    const { name, value } = event.target;

    const change = { [name]: value };
    const modified: TemplateTextTypeModel = { ...templateTextType, ...change };

    setTemplateTextType(modified);
  };

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{modalText}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit} id="templateTextTypeForm">
            {errors[""] && (
              <div style={{ marginTop: "1rem" }}>
                {errors[""].map((errorMessage, index) => (
                  <Alert key={errorMessage} variant="danger">
                    <p key={index}>{errorMessage}</p>
                  </Alert>
                ))}
              </div>
            )}
            <Form.Group>
              <Form.Label>Name</Form.Label>
              <Form.Control
                name="name"
                type="text"
                defaultValue={templateTextType.name}
                onChange={handleChange}
              />
              {errors.name && (
                <div style={{ marginTop: "1rem" }}>
                  {errors.name.map((e, index) => (
                    <Alert key={e} variant="danger">
                      <p>{e}</p>
                    </Alert>
                  ))}
                </div>
              )}
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" form="templateTextTypeForm" type="submit">
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default TemplateTextTypeModal;
